import { createSlice } from "@reduxjs/toolkit";
import {
  getAllBookings,
  getAllBookingTimes,
  getOneBooking,
  seeNowPrice,
} from "./thunk";

const initialState = {
  bookings: { data: [] },
  oneBooking: [],
  currentPriceData: null,
  bookingTimes: null,
  loading: false,
  error: null,
};

const bookingSlice = createSlice({
  name: "bookingSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ✅ GET ALL bookings
    builder
      .addCase(getAllBookings.pending, (state) => {
        state.loading = true;
        state.bookings = [];
        state.error = null;
      })
      .addCase(getAllBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = action.payload;
      })
      .addCase(getAllBookings.rejected, (state, action) => {
        state.loading = false;
        state.bookings = [];
        state.error = action.error.message;
      });
    // ✅ GET  one Booking
    builder
      .addCase(getOneBooking.pending, (state) => {
        state.loading = true;
        state.oneBooking = [];
        state.error = null;
      })
      .addCase(getOneBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.oneBooking = action.payload;
      })
      .addCase(getOneBooking.rejected, (state, action) => {
        state.loading = false;
        state.oneBooking = [];
        state.error = action.error.message;
      });

    // ✅ GET all BookingTimes
    builder
      .addCase(getAllBookingTimes.pending, (state) => {
        state.loading = true;
        state.bookingTimes = null;
        state.error = null;
      })
      .addCase(getAllBookingTimes.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingTimes = action.payload;
      })
      .addCase(getAllBookingTimes.rejected, (state, action) => {
        state.loading = false;
        state.bookingTimes = null;
        state.error = action.error.message;
      });
  },
});

export default bookingSlice.reducer;
